import Client from '@/clients/apiClient';
import humps from 'humps';
import { stringify } from 'query-string';

const resource = 'loans';

export default {
  get(payload) {
    return Client.get(
      `/${resource}?page=${payload.page}&limit=${payload.perPage}&sort[field]=${humps.decamelize(
        payload.sort.field
      )}&sort[type]=${payload.sort.type}&${stringify(humps.decamelizeKeys(payload.filters))}`
    );
  },
  show(id) {
    return Client.get(`${resource}/${id}`);
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`);
  },
  pay(id, data) {
    return Client.post(`${resource}/${id}`, data);
  },
  extend(id, data) {
    return Client.post(`${resource}/${id}/extend`, data);
  },
  writeOff(id, data) {
    return Client.post(`${resource}/${id}/write-off`, data);
  },
  lending(id) {
    return Client.post(`${resource}/${id}/lending`, { id });
  },
  sendSMS(id, payload) {
    return Client.post(`${resource}/${id}/send-sms`, payload);
  },
  downloadNotice(id) {
    return Client.post(`${resource}/${id}/download-document`);
  },
};
